import React from "react";
import { DataProps } from "types";
import { MemoItem } from "components";
import { View, Button, Text, Icon } from "ui";
import { groupByExpirationStatus } from "pages/alertList/util";
import AddMemoModal from "pages/AddMemoModal";
import { notify } from "../../shared/services/notify";
import { RouteComponentProps } from "react-router";
// {
//   title: "Adauga vehicul",
//   textColor: "primary",
//   icon: <FaCar size={20} />,
//   color: "white",
//   onClick: () => componentInstance.handleAddVehicle()
// },
// {
//   title: "Adauga altele",
//   textColor: "primary",
//   icon: <FaClipboardList size={20} />,
//   color: "white",
//   onClick: () => componentInstance.handleAddOther()
// },

export default class Memos extends React.Component<DataProps & RouteComponentProps> {
  public state = {
    open: false,
    categoryId: undefined
  };
  public handleAddClose = () => {
    this.setState({ open: false });
  }
  public handleAddMemo = () => {
    if (!this.props.currentUser.subscribed) {
      notify("Ai nevoie de un abonament activ pentru a creea memo-uri");
      this.props.history.push("/app/abonament");
      return;
    }
    this.setState({ open: true });
  }

  public render() {
    const { memos, categories, findMemoAlerts, findMemoPhotos } = this.props;
    const { open } = this.state;
    return (
      <View flexDirection="column">
        <Button mx={2} mb={2} alignItems="center" onClick={this.handleAddMemo}>
          <Icon name="plus-circle-outline" size={2} color="white" />
          <Text ml={1} fontSize={4} color="white">
            Adauga Memo
          </Text>
        </Button>
        {memos.map(memo => {
          const alerts = findMemoAlerts(memo.id);
          const photos = findMemoPhotos(memo.id);
          const groupedAlerts = groupByExpirationStatus(alerts);
          return (
            <MemoItem
              id={memo.id}
              key={memo.id}
              title={memo.name}
              expiredAlerts={(groupedAlerts.expired || []).length}
              activeAlerts={(groupedAlerts.active || []).length}
              image={photos.length ? photos[0].uri : undefined}
            />
          );
        })}
        {open && (
          <AddMemoModal onClose={this.handleAddClose} categories={categories} />
        )}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/main/Memos.tsx